module.exports = __webpack_public_path__ + "44c3857f0c0c0c33e12ba8b78c0fc9af.pdf";